import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { BrandLogo } from '../../shared/BrandLogo'
import { ibApi, IbApiError } from '../api'

export function IbForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [info, setInfo] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    setInfo('')
    try {
      const res = await ibApi.forgotPassword(email.trim())
      setInfo(res.message || 'If an IB account exists for that email, a reset link has been sent.')
    } catch (err) {
      setError(err instanceof IbApiError ? err.message : 'Unable to send reset link')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="ap-auth ap-auth--ib">
      <div className="ap-auth__card">
        <BrandLogo className="ap-auth__logo" tone="light" variant="mark" />
        <p className="cp-eyebrow">IB / Sub-admin</p>
        <h1>Forgot password</h1>
        <p className="cp-muted">We will email a secure reset link if a partner account exists.</p>
        {error ? (
          <p className="cp-error" role="alert">
            {error}
          </p>
        ) : null}
        {info ? <p className="cp-success">{info}</p> : null}
        <form className="cp-auth__form" onSubmit={(e) => void onSubmit(e)}>
          <label className="cp-field">
            <span className="cp-field__label">Email</span>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <Button type="submit" disabled={busy}>
            {busy ? 'Sending…' : 'Send reset link'}
          </Button>
        </form>
        <p className="cp-auth__signin">
          <Link to="/ib/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
